// Runtime container configuration takes precedence over the local Vite build flag.
// Activation still requires the matching backend capabilities.
const runtimeFlag = typeof window !== 'undefined'
  ? window.__APP_CONFIG__?.MULTI_PACKAGE_LABEL_GENERATION_ENABLED
  : undefined;

export const MULTI_PACKAGE_LABEL_GENERATION_ENABLED =
  (runtimeFlag ?? import.meta.env.VITE_MULTI_PACKAGE_LABEL_GENERATION_ENABLED) === 'true';

export function isMultiPackageLabelGenerationEnabled(override?: boolean): boolean {
  return override ?? MULTI_PACKAGE_LABEL_GENERATION_ENABLED;
}
